import ApiService from "./ApiService";
import { CriteriaGroupsDeleteRequest, CriteriaGroupsDeleteResponse, CriteriaGroupsGetResponse, CriteriaGroupsPostRequest, CriteriaGroupsPostResponse, CriteriaGroupsPutRequest, CriteriaGroupsPutResponse } from "src/entities/CriteriaGroupEntity";

export const criteriaGroupQueryKeys = {
	groups: (id: string) => ["criteria", id, "groups"] as const,
};

export default class CriteriaGroupService extends ApiService {
	public async getGroups(criteriaId: number) {
		return await this.request.get<CriteriaGroupsGetResponse>(`/api/v1/criteria/${criteriaId}/groups`);
	}
	public async postGroups(data: CriteriaGroupsPostRequest) {
		return await this.request.post<CriteriaGroupsPostResponse>(`/api/v1/criteria/groups`, data);
	}
	public async putGroups(data: CriteriaGroupsPutRequest) {
		return await this.request.put<CriteriaGroupsPutResponse>(`/api/v1/criteria/groups`, data);
	}
	public async deleteGroups(data: CriteriaGroupsDeleteRequest) {
		return await this.request.post<CriteriaGroupsDeleteResponse>(`/api/v1/criteria/groups/delete`, data);
	}
}
